import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-profile',
  templateUrl: './single-profile.component.html',
  styleUrls: ['./single-profile.component.scss']
})
export class SingleProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
